module.exports = __webpack_public_path__ + "assets/img/driver-btn-dde23b06.png";